export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/collage_pattern.71233c7.svg";